export const request = {
  javascript: [
    `var settings = {
  "url": "https://partner.tst.auws.cloud/v2/auth/signup",
  "method": "POST",
  "timeout": 0,
  "headers": {
    "Content-Type": "application/json",
    "X-AU-Key": "XXXX",
    "X-AU-Token": "XXXX"
  },
  "data": JSON.stringify({
    "email": "test@grr.la",
    "password": "Tt123123#",
    "brand": "AkashX",
    "title": "",
    "firstName": "Test XYZ",
    "lastName": "gl",
    "latinFirstName": "",
    "latinLastName": "",
    "dateOfBirth": "1995-01-01",
    "phone": "+14087150749",
    "province": "",
    "postCode": "1254",
    "countryCode": "US",
    "city": "Cityone",
    "addressLine1": "asdfgh",
    "addressLine2": "jhgfd",
    "addressLine3": "",
    "state": "Illinois"
  }),
};

$.ajax(settings).done(function (response) {
  console.log(response);
});`,
  ],

  shell: [
    `wget --no-check-certificate --quiet 
--method POST 
--timeout=0 
--header 'Content-Type: application/json' 
--header 'X-AU-Key: XXXX' 
--header 'X-AU-Token: XXXX' 
--body-data '{    
  "email": "tst@grr.la",
  "password": "123123",
  "brand" : "AkashX",
  "title": "",
  "firstName": "Test XYZ",
  "lastName": "gl",
  "latinFirstName": "",
  "latinLastName": "",
  "dateOfBirth": "1995-01-01",
  "phone": "+14087150749",
  "province": "",
  "postCode": "1254",
  "countryCode": "US",
  "city": "Cityone",
  "addressLine1": "asdfgh",
  "addressLine2": "jhgfd",
  "addressLine3": "",
  "state": "Illinois"
}' 
'https://partner.tst.auws.cloud/v2/auth/signup'`,
  ],

  ruby: [
    `require "uri"
require "json"
require "net/http"

url = URI("https://partner.tst.auws.cloud/v2/auth/signup")

https = Net::HTTP.new(url.host, url.port)
https.use_ssl = true

request = Net::HTTP::Post.new(url)
request["Content-Type"] = "application/json"
request["X-AU-Key"] = "XXXX"
request["X-AU-Token"] = "XXXX"
request.body = JSON.dump({
  "email": "test@grr.la",
  "password": "T123#123",
  "brand": "AkashX",
  "title": "",
  "firstName": "Test XYZ",
  "lastName": "gl",
  "latinFirstName": "",
  "latinLastName": "",
  "dateOfBirth": "1995-01-01",
  "phone": "+14087150749",
  "province": "",
  "postCode": "1254",
  "countryCode": "US",
  "city": "Cityone",
  "addressLine1": "asdfgh",
  "addressLine2": "jhgfd",
  "addressLine3": "",
  "state": "Illinois",
})

response = https.request(request)
puts response.read_body`,
  ],

  python: [
    `import requests
import json

url = "https://partner.tst.auws.cloud/v2/auth/signup"

payload = json.dumps({
  "email": "test@grr.la",
  "password": "T123123#",
  "brand": "AkashX",
  "title": "",
  "firstName": "Test XYZ",
  "lastName": "gl",
  "latinFirstName": "",
  "latinLastName": "",
  "dateOfBirth": "1995-01-01",
  "phone": "+14087150749",
  "province": "",
  "postCode": "1254",
  "countryCode": "US",
  "city": "Cityone",
  "addressLine1": "asdfgh",
  "addressLine2": "jhgfd",
  "addressLine3": "",
  "state": "Illinois"
})
headers = {
  'Content-Type': 'application/json',
  'X-AU-Key': 'XXXX',
  'X-AU-Token': 'XXXX'
}

response = requests.request("POST", url, headers=headers, data=payload)

print(response.text)`,
  ],
};

export const response = {
  success: [
    `{
  "status": "success",
  "data": {
    "contactId": "2cd3165c-8c73-4062-aae2-e52024ccfd01",
    "emailAddress": "test06@grr.la"
  },
  "error": {},
  "message": "User is created"
}`,
  ],
  error: [
    `{
  "status": "fail",
  "data": {
    "title": null,
    "instance": "/v2/partner/signup"
  },
  "error": {
    "code": 40901,
    "reason": "ConflictAuthUser",
    "message": "User is already exists"
  },
  "message": "User is already exists",
}`,

    `{
  "status": "fail",
  "data": {
    "instance": "/v2/partner/signup",
    "invalid-params": {
      "dateOfBirth": [
        "The dateOfBirth field is required."
      ]
    }
  },
  "error": {
    "code": 40001,
    "data": {
      "invalid-params": {
        "dateOfBirth": [
          "The dateOfBirth field is required."
        ]
      }
    },
    "reason": "ValidationInvalidField",
    "message": "Invalid parameter(s)"
  },
  "message": "Invalid parameter(s)"
}`,
  ],
};
